/**
 * Ícone próprio do Escritório (SPEC-20261010-1715): a plantinha de um andar
 * (duas salas em cima, corredor, porta embaixo) com uma setinha voltando.
 * Serve para "voltar ao tabuleiro"; os quatro quadradinhos já têm outro
 * sentido no Orbind.
 */
export function IconePlanta({ tamanho = 18, comSeta = true }: { tamanho?: number; comSeta?: boolean }) {
  return (
    <svg className="ico-planta" width={tamanho} height={tamanho} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinejoin="round" strokeLinecap="round" aria-hidden>
      {/* o andar */}
      <path d="M3 3.5h14v13H11.5M8.5 16.5H3v-13" />
      {/* as duas salas de cima e o corredor */}
      <path d="M3 8.5h14M10 3.5v5" />
      {comSeta ? (
        /* a setinha de volta, dentro do corredor */
        <path d="M13.5 12.5H7.2m0 0 1.9-1.8M7.2 12.5l1.9 1.8" />
      ) : (
        <path d="M6.5 12.5h7" />
      )}
    </svg>
  )
}
